import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

type FilesRootLayoutProps = {
  children: React.ReactNode;
  moduleNavigation?: NavItem;
  className?: string;
};

export const FilesRootLayout = ({
  children,
  moduleNavigation,
  className,
}: FilesRootLayoutProps) => (
  <ModuleLayout
    showSecondLevelNav
    moduleNavigation={moduleNavigation}
    noContentPadding={true}
    className={cn('@FilesRootLayout', className)}
  >
    {children}
  </ModuleLayout>
);
